const entityTraits = {
  name: 'entity-traits',
  options: {
    showInMenu: false
  }
}

export default entityTraits;